<template>
  <div v-if="!mobileCheck()">
    <el-table
      ref="cargoTable"
      class="BlackList"
      style="width: 100%"
      :data="tableData"
    >
      <el-table-column width="100">
        <template slot="header" slot-scope="scope">
          <SortableHeader label="Type" :order="order" prop="rank" @sortData="sortData"/>
            <el-popover
              placement="top-start"
              trigger="hover"
            >
              <div class="tip-content">Top 15 Supernodes and Candidate Nodes.</div>
              <span class="tips" slot="reference">?</span>
            </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="cell-rank" :class="{nodes: scope.row.rank<=count}">{{scope.row.rank<=count?"Supernode":"Candidate"}}</div>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="Name" width="199">
        <template slot-scope="scope">
          <Name style="display: inline" :name="scope.row.name" :logo="scope.row.logo" :href="scope.row.website" :sub-node="scope.row.subNode"/>
          <el-button :id="scope.row.id" class="expand-button" type="text" @click="toogleExpand(scope.row)">&#x25B3</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="VSYS Staking">
        <el-table-column width="105"  align="center">
          <template slot="header" slot-scope="scope">
            <!-- <SortableHeader label="Fee" :order="order" prop="fee" @sortData="sortData"/> -->
            Yield
          </template>
          <template slot-scope="scope">
            <div>
              {{formatPercent(scope.row.fee,2)}}
            </div>
          </template>
        </el-table-column>

        <el-table-column width="135" align="center">
          <template slot="header" slot-scope="scope">
            <!-- SortableHeader label="Cycle"
                            :order="order" prop="cycle" @sortData="sortData"/> -->
            Distribution
            <el-popover
              placement="top-start"
              trigger="hover"
              >
              <div class="tip-content">If your expected yield is lower than the transaction fee (0.1 VSYS), you will not receive any return on the coins you staked.</div>
              <img slot="reference" class="caution" src="../../assets/ic_alarm_small_line.svg">
            </el-popover>
          </template>
          <template slot-scope="scope">
            <div class="cell-item">
              {{formatCycle(scope.row.cycle)}}
            </div>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column prop="address" label="Node Address" min-width="220">
        <template slot="header" slot-scope="scope">
          <span class="cell-header">Node Address</span>
          <el-popover
            placement="top-start"
            trigger="hover"
          >
            <div class="tip-content">The Supernode wallet address used to collect the leased coins. Click on the address to check it in the VSYS explorer.</div>
            <span class="tips" slot="reference">?</span>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <a
            :href="`https://mainnetexplorer.v.systems//nodeInfo/${scope.row.address}`"
            target="_blank"
          >{{scope.row.address}}</a>
          <img :plain="true" @click="open" class="clip" src="../../assets/ic_copy.svg" v-clipboard:copy="scope.row.address"/>
          <el-popover
            placement="right"
            trigger="click"
          >
            <img src="../../assets/ic_qr_code.svg" class="qrcode-btn" slot="reference"/>
            <QRCode :msg="scope.row.address"/>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column min-width="150">
        <template slot="header" slot-scope="scope">
          <SortableHeader label="Capacity"
                          :order="order" prop="currentCapacity" @sortData="sortData"/>
          <el-popover
            placement="top-start"
            trigger="hover"
          >
            <div class="tip-content">The total amount of coins that can be leased to the Supernode. When it is at capacity, the Supernode will stop distributing yield.</div>
            <span class="tips" slot="reference">?</span>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="flex">
            <Capacity :total="scope.row.capacity" :current="scope.row.currentCapacity"/>
            <el-popover
              placement="top-end"
              trigger="hover"
              v-if="scope.row.capacity<=scope.row.currentCapacity"
              >
              <div class="tip-content">The Supernode is full, you will not be able to receive any staking rewards if you lease VSYS to this address.</div>
              <span class="fullTip" slot="reference">Full</span>
            </el-popover>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="right" min-width="128">
        <template slot="header" slot-scope="scope">
          <SortableHeader label="Efficiency"
                          :order="order" prop="efficiency" @sortData="sortData"/>
          <el-popover
            placement="top-start"
            trigger="hover"
          >
            <div class="tip-content">The block production performance. This can significantly affect the yields generated.</div>
            <span class="tips" slot="reference">?</span>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="cell-item" v-if="scope.row.efficiency>=0">
            {{formatPercent(scope.row.efficiency, 2)}}
          </div>
        </template>
      </el-table-column>
      <el-table-column type="expand" width="1">
        <template slot-scope="scope">
          <SubNode :name="scope.row.name" :logo="scope.row.logo" :href="scope.row.website" :sub-node="scope.row.subNode"/>
        </template>
      </el-table-column>
      <template slot="empty">{{ emptyText }}</template>

      <!-- <el-table-column prop="country" label="Country/Area" align="right" min-width="140">
      </el-table-column> -->
    </el-table>
  </div>
  <div v-else>
    <template v-if="hasTableData">
      <div class="item" v-for="item in tableData" :key="item.id || item.address">
        <NodeItem  :nodeData="item"/>
      </div>
    </template>
    <div v-else class="empty-state">{{ emptyText }}</div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { mobileCheck } from '@/utils/common';
  import { formatCycle, formatPercent } from '@/utils/data_parse';
  import NodeItem from '@/components/commons/NodeItem';
  import Name from './tablecell/Name';
  import Capacity from './tablecell/Capacity';
  import SortableHeader from './tablecell/SortableHeader';
  import QRCode from '../commons/QRCode';
  import SubNode from './tablecell/SubNode';

  export default {
    name: 'NodeList',
    components: {
      Name,
      Capacity,
      SortableHeader,
      QRCode,
      SubNode,
      NodeItem,
    },
    props: {
      tableData: {
        type: Array,
        default: () => [],
      },
      tokensList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        down: false,
        order: '',
        value: 'IPX',
      };
    },
    computed: {
      ...mapState('nodes', ['count', 'listLoading']),
      hasTableData() {
        return Array.isArray(this.tableData) && this.tableData.length > 0;
      },
      emptyText() {
        return this.listLoading ? 'Loading Data' : 'No Data';
      },
      tokens() {
        const temp = [];
        if (this.tokensList.length > 0) {
          this.tokensList.forEach((item) => {
            temp.push({
              value: item.name,
              label: item.name,
              img: item.logo,
            });
          });
        }
        return temp;
      },
    },
    methods: {
      formatCycle,
      formatPercent,
      mobileCheck() {
        return mobileCheck();
      },
      toogleExpand(row) {
        const $table = this.$refs.cargoTable;
        if (document.getElementById(row.id).innerText.charCodeAt(0) === 9651) {
          document.getElementById(row.id).innerHTML = '&#9660';
        } else {
          document.getElementById(row.id).innerHTML = '&#x25B3';
        }
        $table.toggleRowExpansion(row);
      },
      sortData(a) {
        this.order = a.order;
        this.$store.commit('nodes/sortList', {
          order: a.order,
        });
      },
      open() {
        this.$message({
          message: 'Copy successfully',
          type: 'success',
          duration: 1000,
          customClass: 'messageWeb',
        });
      },
      staking(data) {
        let fee = 0;
        let cycle = '';
        if (Array.isArray(data)) {
          data.forEach((item) => {
            if (item.name === this.value) {
              fee = item.TokenFee || 0;
              cycle = item.TokenCycle || '';
            }
          });
        }
        return { fee, cycle };
      },
      income(data) {
        const tokenData = data.tokenData;
        let tokenValue = '';
        if (tokenData && tokenData.length > 0) {
          tokenData.forEach((item) => {
            if (item.name === this.value) {
              tokenValue = (item.mint_amount / item.mint_day / 15 / data.currentCapacity
              * (1 - item.return_rate)).toFixed(8);
            }
          });
        }
        return tokenValue;
      },
    },
  };
</script>

<style lang="scss">
  .cell {
    &-item {
      padding-right: 16px;
    }
    &-rank {
      display: inline-block;
      // width: 30px;
      // width: 70px;
      // min-width:70px;
      padding: 2px;
      text-align: center;
    }
    &-sortable {
      cursor: pointer;
    }

    &-header{
      margin-right: 6px;
    }
  }

  .nodes {
    color: #FFAA70;
    padding: 0;
  }

  .el-table {
    .sort-caret.ascending.active {
      border-bottom-color: #409EFF;
    }
    .sort-caret.descending.active {
      border-top-color: #409EFF;
    }
    .cell{
      white-space:inherit !important;
    }
    thead.is-group th {
      background: white !important;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 10px 11px;
      background: #F7F7FA;
    }
    // th>.cell{
    //   white-space: nowrap!important;
    //   text-overflow: clip!important;
    // }
    // .cell{
    //   // min-width: 100px;
    //   // white-space: nowrap!important;
    // }
  }

  .expand-button {
    vertical-align: middle !important;
    color: #FF8737 !important;
    font-size: 20px !important;
    margin-left: 5px !important;
  }

  .tips{
    color: #FF8737;
    cursor: pointer;
    border: 1px solid;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: inline-block;
    line-height: 13px;
    text-align: center;
    font-size: 12px;
  }
  .tip-content{
    width: 250px;
    text-align: left;
    word-break: break-word;
  }
  .flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .fullTip{
    font-size: 12px;
    color: #FF8837;
    border: 1px solid #FF8837;
    padding-left: 4px;
    padding-right: 4px;
    height: 15px;
    line-height: 15px;
    border-radius: 3px;
    cursor: pointer;
  }
  .qrcode-btn{
    cursor: pointer;
    width: 14px;
    height: 14px;
    position: relative;
    left: 20px;
    top: 2px;
  }
  .clip{
    position: relative;
    left: 8px;
    top: 2px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
  .messageWeb{
    top: 400px !important;
    min-width: 180px !important;
    background-color: white !important;
  }
  .messageWeb >  .el-message__content{
    color: #323233 !important;
  }
  .caution{
    cursor: pointer;
  }

  /************mobile***************/
  .item + .item{
    margin-top: 0.15rem;
  }

  .empty-state{
    padding: 40px 0;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }
</style>
